import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appGodziny]'
})
export class GodzinyDirective {
  @Input() min: number = 0;
  @Input() max: number = 24;

  private previousValue: string = '';

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Blokuj klawisze: -, +, e, E
    if (['-', '+', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('focus')
  onFocus() {
    this.previousValue = this.el.nativeElement.value;
  }

  @HostListener('input')
  onInput() {
    const input = this.el.nativeElement;
    const currentValue = input.value;

    // Pozwól na pustą wartość
    if (currentValue === '') {
      this.previousValue = '';
      return;
    }

    // Zamień przecinek na kropkę
    const normalized = currentValue.replace(',', '.');

    // Pozwól na wartości kończące się kropką (stan pośredni np. "8.")
    if (normalized.endsWith('.')) {
      const intPart = parseFloat(normalized.slice(0, -1));
      if (!isNaN(intPart) && intPart >= this.min && intPart <= this.max) {
        this.previousValue = currentValue;
        return;
      }
    }

    const value = parseFloat(normalized);

    // Jeśli wartość jest nieprawidłowa lub poza zakresem - przywróć poprzednią
    if (isNaN(value) || value < this.min || value > this.max) {
      input.value = this.previousValue;
    } else {
      this.previousValue = currentValue;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const normalized = pastedText.replace(',', '.');
    const value = parseFloat(normalized);

    if (!isNaN(value) && value >= this.min && value <= this.max) {
      this.el.nativeElement.value = pastedText;
      this.previousValue = pastedText;
      // Wywołaj zdarzenie input aby Angular zaktualizował model
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  @HostListener('blur')
  onBlur() {
    const current = this.el.nativeElement.value.replace(',', '.');
    const value = parseFloat(current);

    if (!isNaN(value)) {
      if (value < this.min) {
        this.el.nativeElement.value = this.min;
      } else if (value > this.max) {
        this.el.nativeElement.value = this.max;
      }
    }
  }
}
